module.exports = __webpack_public_path__ + "static/4-Cosas que Quedaron sin Decir-59c7a9bbdf6eb95999e5419cce9dbe92.jpg";